import React from 'react';

/**
 * 
 * @param {children, color, classe} props 
 * @returns span element
 */
const  Span = (props) => {

    const {
        children,
        size,
        classe
    } = props

    let colorTitle, sizeSpan

    if(size === "small") sizeSpan = "text-base md:text-md"
    else sizeSpan = "text-md md:text-lg"

    return (
        <span className={`
            ${classe}
            ${sizeSpan}
            font-extrabold
            font-nunito
            text-tersio
        `}>
            { children }
        </span>
    );
}

export default Span;
